// Route optimizer target. true → ALL optimize requests go to the Cloud Run optimizer
// (async ?distributed=true + sync ?useCloudRunSync=true); false → ALL go to the legacy
// GKE optimizer. Single kill-switch (the per-request UI toggles were removed) — flip to
// false to instantly revert every optimize path back to GKE, no other change needed.
export const USE_CLOUD_RUN_OPTIMIZER = true;

// Paginated digital-twin vehicle selector (vehicle pagination plan). When true, the selector loads
// vehicle categories + counts and per-category paginated pages from the server and does NOT hold the
// whole fleet in the browser. false = legacy full-fleet load. Kept OFF until the new flow is fully
// wired + verified, then flipped; flip back for instant revert.
export const USE_PAGINATED_VEHICLE_SELECTOR = true;

export const SNACK_BAR_DURATION = 5000; // in milliseconds
export const SPACE_BETWEEN_CONTAINER_CARDS = 5; // in px
export const color = {
  FFFFFF: '#FFFFFF',
  ECF4FF: '#ECF4FF',
  ffb4b3: '#ffb4b3',
  D3D3D3: '#D3D3D3',
  ff8e54: '#ff8e54'
};
// attachment related constants
export const UPLOAD_FILE_MAXIMUM_SIZE = 20971520;
export const MINIMUM_IMAGE_HEIGHT = 100;
export const MINIMUM_IMAGE_WIDTH = 200;
export const ATTACH_IMAGE = 'Attach';
export const RE_ATTACH_IMAGE = 'Re-Attach';
export const RE_UPLOAD_IMAGE = 'Re-Upload';
export const IMAGE_DIMENSION_VALIDATION = '100x200 or larger Recommended';
export const FILE_MAX_SIZE_EXCEED = 'file is too large';
// vertical related constants
export const COMMON_VERTICAL = 'VERT-CMN';
export const CUSTOMS_HOUSE_BROKERAGE = 'VERT-CHB';
// purpose related constants
export const FUMIGATION = 'PPS-FMG';
export const STOPOVER = 'PPS-STPOVR';
// scope related constants
export const ADMIN_SCOPE = 'admin:super';
export const GPS_DEVICE_VIEW_SCOPE = 'view:gps-device-mgt';
export const GPS_DEVICE_EDIT_SCOPE = 'edit:gps-device-mgt';
export const GPS_DEVICE_ADD_SCOPE = 'add:gps-device-mgt';
// aggregated map
export const NOT_ASSIGNED_TO_JOB = 'Not Assigned to a Job';

// workflow
export const LOCAL_HAULAGE_REPO = 'LF-RP-YP';
export const LOCAL_HAULAGE_DI = 'LF-DI-FTL';
export const LOCAL_HAULAGE_REMOVAL = 'LF-RM-PY';
export const LOCAL_HAULAGE_RELOCATION = 'LF-CRL';
export const FIELD_SERVICES = 'FS-FA';
export const LOCAL_HAULAGE = 'LF-RL';
export const DEFAULT_RESOURCE = 'UNKNOWN';
export const DISTRIBUTION_WF = 'LF-DI-FTL';
export const FOOT_TO_METER_MULTIPLIER = 0.3048;
export const DOMESTIC_WF = 'LF-DO-FTL';
export const OTHER_REF_ID = 'TRN-MON-11650';
export const ORDER_REF_ID = 'TRN-MON-11651';

// mandatory work order id
export const ACCEPT_THE_JOB1_ID = 'TRN-MON-10450';
export const ACCEPT_THE_JOB2_ID = 'TRN-MON-10455';
export const START_THE_JOB_ID = 'START-JOB';
export const END_THE_JOB1_ID = 'END-JOB';
export const END_THE_JOB2_ID = 'TRN-MON-10850';
export const END_THE_TRIP_ID = 'TRN-MON-10860';
export const RECEIVE_SUPPORTING_DOCUMENTS_ID = 'TRN-MON-60170';
export const ENTER_START_ODOMETER_READING_ID = 'TRN-MON-10400';
export const ENTER_END_ODOMETER_READING_ID = 'TRN-MON-10800';
export const START_TRIP_ID = 'TRN-MON-10460';
export const MARK_THE_CHANNEL = 'TRN-MON-15300';
export const PICK_THE_CONTAINER = 'TRN-MON-11700';
export const SELECT_EMPTY_CONTAINER = 'TRN-MON-20100';
export const INFORM_TERMINAL = 'TRN-MON-15500';

// Routing values
export const APP_ROUTING = {
  main: '',
  taskFeed: {
    main: '/task-feed',
    v2: '/task-feed/v2',
  },
  dashboard: {
    main: '/dashboard',
  },
  jobGroup: {
    main: '/job-group'
  },
  wizard: {
    main: '/wizard',
    jobFile: '/wizard/job-file',
    optimized: '/wizard/container-management',
    jobPlanning: '/wizard-v2/job-planning',
    jobplanningManual: '/load-management'
  },
  // TODO: add other modules routes here
  auth: {
    main: '/auth',
    login: '/auth/login'
  },
  schedule: {
    main: '/schedule'
  },
  invoice: {
    main: '/invoice',
  },
  rateCardManager: {
    main: '/rate-card-manager'
  },
  runSheet: {
    main: '/run-sheet'
  },
  apiManagement: {
    main: '/api-management'
  },
  reports: {
    main: '/reports',
    jobMater: '/reports/job-master',
    downloads: '/reports/download',
  },
  organizationsManager: {
    main: '/organizations-manager/organizations/general-details'
  },
  aggregatedJPM: {
    main: '/aggregated-jpm',
    map: '/aggregated-jpm/map'
  },
  contracts: {
    main: '/contract'
  },
  fuel: {
    main: '/fuel'
  },
  quotation: {
    main: '/quotation',
  },
  controlTower: {
    main: '/control-tower'
  },
  orderManagement: {
    main: '/order-management'
  },
  contractManagement: {
    main: '/contract-management'
  },
  loadAssignment: {
    main: '/load-assignment'
  }
}
